// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"c4184f38","160":"19a0aa43","208":"8e314f3f","293":"239a1b9e","516":"c28a3db4","519":"77c104c2","917":"14a40299","946":"ca24da11"}[chunkId] + ".chunk.js";
};